import { makeSx } from '@saas/lib/shared-utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    root: {
        flexGrow: 1,
        // // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        // backgroundColor: theme.palette.background.paper,
    },
    tabs: {
        marginBottom: '5px',
        background: defaultPalette.white.main,
        '& .MuiButtonBase-root': {
            color: defaultPalette.typography.light,
            fontWeight: 800,
        },
        '& .MuiButtonBase-root.Mui-selected': {
            color: defaultPalette.typography.main,
        },
    },
    tabIndication: {
        backgroundColor: defaultPalette.typography.main,
        height: '4px',
        borderRadius: 100,
    },
})
